import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { ContactInfoModelV3 } from '../../../../model/contactInfo'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'

let isLocal = false

const getApiSuffixUrl = (): string | undefined => {
  if (isLocal) {
    return 'https://localhost:59140'
  }
  return getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
}

export const apiGetContactsInfoBySubjectId = async (
  subjectId: number
): Promise<Array<ContactInfoModelV3>> => {
  const apiSuffixUrl = getApiSuffixUrl()
  return await AxiosInstance.get(`${apiSuffixUrl}/api/Contacts/GetBySubjectId/${subjectId}`).then(
    response => {
      if (response.data && response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiPostContactInfo = async (
  contactInfo: ContactInfoModelV3
): Promise<ContactInfoModelV3> => {
  const apiSuffixUrl = getApiSuffixUrl()

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Contacts`, contactInfo).then(response => {
    if (response.data) {
      return response.data
    } else {
      return {} as ContactInfoModelV3
    }
  })
}

export const apiPatchContactInfo = async (
  contactInfo: ContactInfoModelV3
): Promise<ContactInfoModelV3> => {
  const apiSuffixUrl = getApiSuffixUrl()

  return await AxiosInstance.patch(`${apiSuffixUrl}/api/Contacts`, contactInfo).then(response => {
    if (response.data) {
      return response.data
    } else {
      return {} as ContactInfoModelV3
    }
  })
}

export const apiDeleteContactInfo = async (contactInfoId: number): Promise<any> => {
  const apiSuffixUrl = getApiSuffixUrl()

  return await AxiosInstance.delete(`${apiSuffixUrl}/api/Contacts/${contactInfoId}`).then(
    response => {
      return response.data
    }
  )
}
